import { combineReducers } from 'redux';

import buildCardsReducer from './ducks/buildCards';
import filtersReducer from './ducks/filters';
import jobsReducer from './ducks/jobs';
import usersReducer from './ducks/users';

const reducers = {
  buildCards: buildCardsReducer,
  filters: filtersReducer,
  jobs: jobsReducer,
  users: usersReducer,
};

export default combineReducers(reducers);
